import { combineReducers } from 'redux';
import settings from './settings';
import status from './status';

export default combineReducers({
  settings,
  status
});
